import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SapProject } from '../models/sap-project';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SapProjectService {

  constructor( private http:HttpClient ) { }

  getProjects() : Promise<SapProject[]> {
    return this.http.get<SapProject[]>('/api/projects-sap').toPromise();
  }
}
